// src/data/services.js
import img1 from '../'

export const servicesData = [
  {
    id: 1,
    title: "Wall Graphic Lettering",
    meta_title: "Custom Wall Graphic Lettering | A2Z Signs USA",
    meta_description: "A2Z Signs offers custom wall graphic lettering for businesses across the USA. Transform your walls with bold, eye-catching designs. Based in Upland, CA. Free quote available today!",
    keywords: "Custom Wall Graphic Lettering USA",
    paragraphs: [
      "Professional wall graphic lettering solutions designed to improve interior branding, business visibility, and customer engagement.",
      "Custom wall lettering is ideal for offices, retail stores, restaurants, gyms, corporate spaces, and commercial environments looking to create a modern and professional appearance",
      "At A2Z Signs, we provide high-quality wall graphic lettering using durable materials, precision-cut designs, and professional installation services to help businesses strengthen brand identity and enhance visual presentation."
    ],
    image: "/images/wall-graphic-lettering.png"
  },
  {
    id: 2,
    title: "Wall Text Lettering",
    meta_title: "Custom Wall Graphic Lettering | A2Z Signs USA",
    meta_description: "A2Z Signs offers custom wall graphic lettering for businesses across the USA. Transform your walls with bold, eye-catching designs. Based in Upland, CA. Free quote available today!",
    keywords: "Custom Wall Graphic Lettering USA",
    paragraphs: [
      "Custom wall text lettering solutions designed to enhance interior branding, communicate business messaging, and create a professional commercial environment.",
      "Wall text lettering is perfect for offices, retail stores, reception areas, restaurants, gyms, and corporate spaces looking to improve visual presentation and customer engagement.",
      "At A2Z Signs, we provide high-quality wall text lettering with precision-cut designs, durable materials, and professional installation services tailored to your branding needs."
    ],
    image: "/images/wall-text-lettering.png"
  },
  {
    id: 3,
    title: "Wall Decals",
    meta_title: "Custom Wall Decals for Business | A2Z Signs USA",
    meta_description: "A2Z Signs provides custom wall decals for businesses across the USA. High-quality, durable, and vibrant designs for every space. Based in Upland, CA. Request your free quote today!",
    keywords: "Custom Wall Decals for Business USA",
    paragraphs: [
      "Professional wall decals designed to enhance interior branding, business decoration, and visual communication for commercial spaces.",
      "Wall decals are ideal for offices, retail stores, restaurants, showrooms, gyms, and corporate environments looking to create a modern and engaging atmosphere.",
      "At A2Z Signs, we provide custom wall decal solutions using high-quality materials, sharp graphics, and professional installation services to help businesses improve brand visibility and interior presentation."
    ],
    image: "/images/window-decals.png"
  },
  {
    id: 4,
    title: "Window Graphic Lettering",
    meta_title: "Window Graphic Lettering for Business | A2Z Signs USA",
    meta_description: "A2Z Signs delivers custom window graphic lettering for businesses across the USA. Boost visibility and brand awareness with stunning window designs. Free quote available today!",
    keywords: "Window Graphic Lettering for Business USA",
    paragraphs: [
      "Professional window graphic lettering solutions designed to improve storefront branding, business visibility, and customer engagement.",
      "Window graphic lettering is ideal for retail stores, offices, restaurants, salons, and commercial businesses looking to create a clean and professional appearance.",
      "At A2Z Signs, we provide custom window graphic lettering using durable vinyl materials, precision-cut designs, and professional installation services to help businesses promote branding, business information, and promotional messaging effectively."
    ],
    image: "/images/window-grahic-lettering.png"
  },
  {
    id: 5,
    title: "Window Text Lettering",
    meta_title: "Custom Window Text Lettering | A2Z Signs USA",
    meta_description: "A2Z Signs offers custom window text lettering for storefronts and offices across the USA. Clean, bold, and professional designs. Based in Upland, CA. Request a free quote today!",
    keywords: "Custom Window Text Lettering USA",
    paragraphs: [
      "Custom window text lettering solutions designed to improve storefront communication, business branding, and professional presentation.",
      "Window text lettering is ideal for displaying business names, operating hours, contact information, promotional messages, and branding graphics on commercial storefronts.",
      "At A2Z Signs, we provide high-quality window text lettering using durable vinyl materials, precision-cut lettering, and professional installation services tailored to your business branding needs."
    ],
    image: "/images/window-text-lettering.png"
  },
  {
    id: 6,
    title: "Window Decals",
    meta_title: "Custom Window Decals for Business | A2Z Signs USA",
    meta_description: "A2Z Signs creates custom window decals for businesses across the USA. Eye-catching, durable, and fully customized to your brand. Based in Upland, CA. Get your free quote today!",
    keywords: "Custom Window Decals for Business USA",
    paragraphs: [
      "Professional window decal solutions designed to improve storefront branding, promotional marketing, and customer engagement[cite: 2].",
      "Window decals are ideal for retail stores, offices, restaurants, salons, and commercial businesses looking to create eye-catching storefront displays and professional business visibility.",
      "At A2Z Signs, we provide custom window decals using high-quality vinyl materials, sharp graphics, and professional installation services designed to support branding, advertising, and long-term durability."
    ],
    image: "/images/window-decals.png"
  },
  {
    id: 7,
    title: "Floor Graphics",
    meta_title: "Custom Floor Graphics for Business | A2Z Signs USA",
    meta_description: "A2Z Signs offers custom floor graphics for retail stores, offices, and businesses across the USA. Durable, slip-resistant, and fully branded. Based in Upland, CA. Free quote today!",
    keywords: "Custom Floor Graphics for Business USA",
    paragraphs: [
      "Custom floor graphics designed to improve business branding, promotional visibility, and customer engagement in commercial spaces.",
      "Floor graphics are ideal for retail stores, offices, shopping centers, restaurants, and event environments looking to create professional and attention-grabbing visual displays.",
      "At A2Z Signs, we provide high-quality floor graphics using durable, slip-resistant materials, sharp printing, and professional installation services for long-lasting performance and strong visual impact."
    ],
    image: "/images/floor-graphics.png"
  },
  {
    id: 8,
    title: "Vehicle Graphics & Lettering",
    meta_title: "Vehicle Graphics And Lettering | A2Z Signs USA",
    meta_description: "A2Z Signs delivers professional vehicle graphics and lettering for businesses across the USA. Turn every vehicle into a moving billboard. Based in Upland, CA. Free quote available!",
    keywords: "Vehicle Graphics and Lettering USA",
    paragraphs: [
      "High-quality vehicle graphics and lettering designed to improve mobile advertising, business branding, and local visibility.",
      "Vehicle graphics are ideal for company cars, trucks, vans, trailers, and commercial fleets looking to create professional brand exposure on the road.",
      "At A2Z Signs, we provide durable vehicle graphics and custom lettering solutions using premium vinyl materials, sharp printing, and professional installation services for long-lasting performance and strong visual impact."
    ],
    image: "/images/vehicle-graphics.png"
  },
  {
    id: 9,
    title: "Rear Window Decals",
    meta_title: "Custom Rear Window Decals for Trucks | A2Z Signs USA",
    meta_description: ": A2Z Signs offers custom rear window decals for trucks and vehicles across the USA. High-quality prints that grab attention on the road. Based in Upland, CA. Get a free quote today!",
    keywords: "Custom Rear Window Decals for Trucks USA",
    paragraphs: [
      "Professional rear window decals designed to improve vehicle branding, promotional visibility, and mobile advertising for businesses.",
      "Rear window decals are perfect for company vehicles, commercial fleets, delivery vans, and service businesses looking to create strong brand exposure while on the road.",
      "At A2Z Signs, we provide high-quality rear window decals using durable perforated vinyl materials, sharp graphics, and professional installation services designed for long-lasting visibility and professional appearance."
    ],
    image: "/images/rear-window-decals.png"
  },
  {
    id: 10,
    title: "Car Magnets",
    meta_title: "Custom Car Magnets for Business | A2Z Signs USA",
    meta_description: "A2Z Signs creates custom car magnets for businesses across the USA. Removable, reusable, and fully branded for your fleet. Based in Upland, CA. Request your free quote today!",
    keywords: "Custom Car Magnets for Business USA",
    paragraphs: [
      "Custom car magnets designed to improve mobile business advertising, brand visibility, and professional promotion for company vehicles.",
      "Car magnets are ideal for contractors, service providers, delivery businesses, and commercial companies looking for flexible and cost-effective vehicle branding solutions.",
      "At A2Z Signs, we provide high-quality car magnets using durable magnetic materials, sharp graphics, and weather-resistant printing designed for long-lasting performance and professional appearance."
    ],
    image: "/images/car-magnets.png"
  },
  {
    id: 11,
    title: "Truck Letters",
    meta_title: "Custom Truck Letters And  Decals | A2Z Signs USA",
    meta_description: "A2Z Signs provides custom truck letters and decals for businesses across the USA. Bold, durable, and weather-resistant designs. Based in Upland, CA. Get your free quote today!",
    keywords: "Custom Truck Letters and Decals USA",
    paragraphs: [
      "Durable truck lettering solutions designed to improve commercial vehicle branding, mobile advertising, and business visibility.",
      "Truck letters are ideal for company trucks, delivery vehicles, contractors, and service businesses looking to create a professional brand presence on the road.",
      "A2Z Signs provides high-quality truck lettering using premium vinyl materials, precision-cut graphics, and expert installation services designed for long-lasting durability and professional appearance."
    ],
    image: "/images/fleet-wraps.png"
  },
  {
    id: 12,
    title: "Boat Lettering",
    meta_title: "Custom Boat Lettering And Graphics | A2Z Signs USA",
    meta_description: "A2Z Signs offers custom boat lettering and graphics across the USA. Marine-grade vinyl designed to last on the water. Based in Upland, CA. Request your free quote today!",
    keywords: "Custom Boat Lettering and Graphics USA",
    paragraphs: [
      "Custom boat lettering solutions designed to improve marine branding, vessel identification, and professional visual appearance.",
      "Boat lettering is ideal for personal boats, commercial vessels, fishing boats, and marine businesses looking for durable and weather-resistant graphics.",
      "Using high-quality vinyl materials and precision-cut lettering, A2Z Signs delivers professional boat lettering solutions designed for long-lasting durability, water resistance, and clean visual presentation."
    ],
    image: "/images/registration-lettering.png"
  },
  {
    id: 13,
    title: "Fabric Banners",
    meta_title: "Custom Fabric Banners for Business | A2Z Signs USA",
    meta_description: "A2Z Signs creates custom fabric banners for businesses and events across the USA. Vibrant, lightweight, and wrinkle-resistant designs. Based in Upland, CA. Free quote available!",
    keywords: "Custom Fabric Banners for Business USA",
    paragraphs: [
      "Professional fabric banners designed to improve event branding, promotional marketing, and business visibility with high-quality printed graphics.",
      "Fabric banners are ideal for trade shows, retail promotions, corporate events, exhibitions, and commercial advertising.",
      "A2Z Signs provides custom fabric banner solutions using premium-quality materials, vibrant printing, and durable finishing designed for long-lasting performance and professional presentation."
    ],
    image: "/images/fabric-banners.png"
  },
  {
    id: 14,
    title: "Banner Stands",
    meta_title: "Retractable Banner Stands for Events | A2Z Signs USA",
    meta_description: "A2Z Signs offers retractable banner stands for trade shows and events across the USA. Portable, professional, and fully customized. Based in Upland, CA. Get your free quote today!",
    keywords: "Retractable Banner Stands for Events USA",
    paragraphs: [
      "Custom pennants designed to improve promotional branding, event visibility, and decorative business displays.",
      "Pennants are ideal for grand openings, sports events, retail promotions, outdoor advertising, and commercial marketing campaigns.",
      "A2Z Signs provides high-quality pennants using durable materials, vibrant printing, and professional finishing designed for long-lasting visibility and attractive presentation."
    ],
    image: "/images/banner-stands.png"
  },
  {
    id: 15,
    title: "Flags",
    meta_title: "Custom Business Flags & Banners | A2Z Signs USA",
    meta_description: "A2Z Signs provides custom business flags and banners for companies across the USA. Bold, eye-catching, and built to last outdoors. Based in Upland, CA. Request a free quote today!",
    keywords: "Custom Business Flags and Banners USA",
    paragraphs: [
      "Professional custom flags designed to improve outdoor branding, promotional visibility, and event advertising for businesses.",
      "Flags are ideal for storefront promotions, trade shows, outdoor events, grand openings, and commercial marketing campaigns.",
      "A2Z Signs provides high-quality flag printing solutions using durable materials, vibrant graphics, and professional finishing designed for long-lasting outdoor performance and strong visual impact."
    ],
    image: "/images/flags.png"
  },
  {
    id: 16,
    title: "Bumper Stickers",
    meta_title: "Custom Bumper Stickers for Business | A2Z Signs USA",
    meta_description: "A2Z Signs offers custom bumper stickers for businesses and brands across the USA. Durable, weather-resistant, and fully customized. Based in Upland, CA. Get your free quote today!",
    keywords: "Custom Bumper Stickers for Business USA",
    paragraphs: [
      "Custom bumper stickers designed to improve brand promotion, business advertising, and mobile visibility for commercial and personal use.",
      "Bumper stickers are ideal for promotional campaigns, company branding, events, and marketing purposes.",
      "A2Z Signs provides high-quality bumper stickers using durable vinyl materials, weather-resistant printing, and strong adhesive finishes designed for long-lasting outdoor performance and professional appearance."
    ],
    image: "/images/bumper-stickers.png"
  },
  {
    id: 17,
    title: "Slim Edge Lit Signs",
    meta_title: "Slim Edge Lit Signs for Business | A2Z Signs USA",
    meta_description: "A2Z Signs creates slim edge lit signs for businesses across the USA. Sleek, modern illuminated signage that enhances your brand. Based in Upland, CA. Request a free quote today!",
    keywords: "Slim Edge lit Signs for business USA",
    paragraphs: [
      "Modern slim edge lit signs designed to improve indoor branding, business visibility, and illuminated visual presentation.",
      "Slim edge lit signs are ideal for retail stores, offices, reception areas, shopping centers, and commercial environments looking for sleek and professional signage solutions.",
      "Custom slim edge lit signs by A2Z Signs feature energy-efficient LED lighting, premium acrylic materials, and professional fabrication for bright visibility and modern business branding."
    ],
    image: "/images/slim-edge-lit-signs.png"
  },
  {
    id: 18,
    title: "Digital Signs",
    meta_title: "Custom Digital Signs for Business | A2Z Signs USA",
    meta_description: "A2Z Signs delivers custom digital signs for businesses across the USA. Dynamic, eye-catching displays that drive customer engagement. Based in Upland, CA. Free quote available!",
    keywords: "Custom Digital Signs for Business USA",
    paragraphs: [
      "Advanced digital signs designed to improve business advertising, customer engagement, and modern brand visibility through dynamic visual displays.",
      "Digital signs are ideal for retail stores, restaurants, shopping centers, corporate offices, and commercial environments looking for high-impact promotional solutions.",
      "Custom digital signage solutions from A2Z Signs use high-resolution display technology, bright visuals, and professional installation services designed for modern business communication and long-lasting performance."
    ],
    image: "/images/digital-displays.png"
  },
  {
    id: 19,
    title: "Neon Signs",
    meta_title: "Custom Neon Signs for Business | A2Z Signs USA",
    meta_description: "A2Z Signs offers custom neon signs for businesses and retail stores across the USA. Bold, vibrant, and built to impress day and night. Based in Upland, CA. Free quote today!",
    keywords: "Custom Neon Signs for Business USA",
    paragraphs: [
      "Custom neon signs designed to improve storefront branding, interior decoration, and business visibility with vibrant illuminated displays.",
      "Neon signs are ideal for restaurants, retail stores, bars, salons, cafes, offices, and commercial spaces looking to create eye-catching visual impact.",
      "Professional neon sign solutions from A2Z Signs use high-quality lighting technology, durable materials, and custom fabrication designed for modern branding and long-lasting performance."
    ],
    image: "/images/neon-signs.png"
  },
  {
    id: 20,
    title: "Floor Mats",
    meta_title: "Custom Logo Floor Mats for Business | A2Z Signs USA",
    meta_description: "A2Z Signs provides custom logo floor mats for businesses across the USA. Make a great first impression at your entrance. Based in Upland, CA. Request your free quote today!",
    keywords: "Custom Logo Floor Mats for Business USA",
    paragraphs: [
      "Custom floor mats designed to improve business branding, floor protection, and customer entrance presentation for commercial spaces.",
      "Floor mats are ideal for offices, retail stores, restaurants, hotels, and commercial environments looking to maintain cleanliness while enhancing professional appearance.",
      "High-quality floor mats from A2Z Signs feature durable materials, custom printed graphics, and long-lasting performance designed for daily commercial use and strong brand visibility."
    ],
    image: "/images/floor-mats.png"
  },
  {
    id: 21,
    title: "Safety Signs",
    meta_title: "Custom Safety Signs for Workplace | A2Z Signs USA",
    meta_description: "A2Z Signs offers custom safety signs for workplaces and businesses across the USA. Keep your team safe with clear, compliant signage. Based in Upland, CA. Free quote available!",
    keywords: "Custom Safety Signs for Workplace USA",
    paragraphs: [
      "Professional safety signs designed to improve workplace safety, hazard communication, and regulatory compliance for commercial and industrial environments.",
      "Safety signs are ideal for construction sites, warehouses, offices, factories, parking areas, and public facilities requiring clear safety instructions and warnings.",
      "Durable safety sign solutions from A2Z Signs use high-visibility graphics, weather-resistant materials, and professional fabrication designed for long-lasting performance and effective communication."
    ],
    image: "/images/safety-signs.png"
  },
  {
    id: 22,
    title: "Traffic Signs",
    meta_title: "Custom Traffic Signs for Business | A2Z Signs USA",
    meta_description: "A2Z Signs provides custom traffic signs for businesses and properties across the USA. Durable, compliant, and clearly visible signage. Based in Upland, CA. Get a free quote today!",
    keywords: "Custom Traffic Signs for Business USA",
    paragraphs: [
      "Professional traffic signs designed to improve road safety, traffic control, and directional guidance for commercial, industrial, and public environments.",
      "Traffic signs are ideal for parking lots, construction zones, private properties, warehouses, and roadway management requiring clear and visible communication.",
      "High-quality traffic sign solutions from A2Z Signs use durable materials, reflective graphics, and weather-resistant fabrication designed for long-lasting outdoor performance and maximum visibility."
    ],
    image: "/images/traffic-signs.png"
  },
  {
    id: 23,
    title: "Menu Boards",
    meta_title: "Custom Menu Boards for Restaurants | A2Z Signs USA",
    meta_description: "A2Z Signs creates custom menu boards for restaurants and cafes across the USA. Stylish, readable, and fully branded displays. Based in Upland, CA. Request your free quote today!",
    keywords: "Custom Menu Boards for Restaurants USA",
    paragraphs: [
      "Custom menu boards designed to improve product presentation, customer experience, and promotional visibility for restaurants, cafes, food trucks, and commercial food businesses.",
      "Menu boards help businesses display pricing, featured items, and branding in a clean and professional format.",
      "Professional menu board solutions from A2Z Signs use high-quality materials, sharp graphics, and custom fabrication designed for long-lasting durability and modern business presentation."
    ],
    image: "/images/menu-boards.png"
  },
  {
    id: 24,
    title: "Menu Boards (Style B)",
    meta_title: "Custom Menu Boards for Restaurants | A2Z Signs USA",
    meta_description: "A2Z Signs creates custom menu boards for restaurants and cafes across the USA. Stylish, readable, and fully branded displays. Based in Upland, CA. Request your free quote today!",
    keywords: "Custom Menu Boards for Restaurants USA",
    paragraphs: [
      "Custom menu boards designed to improve product display, customer experience, and promotional presentation for restaurants, cafes, food trucks, and commercial food businesses.",
      "Menu boards help businesses showcase pricing, offers, and brand messaging in a clear and professional format.",
      "Professional menu board solutions from A2Z Signs use high-quality materials, sharp printing, and custom fabrication designed for long-lasting durability and modern visual appeal."
    ],
    image: "/images/menu-boards.png"
  },
  {
    id: 25,
    title: "Reception Signs",
    meta_title: "Custom Reception Signs for Office | A2Z Signs USA",
    meta_description: "A2Z Signs delivers custom reception signs for offices and businesses across the USA. Make a lasting first impression with premium lobby signage. Based in Upland, CA. Free quote!",
    keywords: "Custom Reception Signs for Office USA",
    paragraphs: [
      "Reception Signs are custom-designed branding elements installed at the entrance or front desk of offices, businesses, and commercial spaces to create a strong and professional first impression.",
      "They help showcase company identity, improve interior aesthetics, and enhance brand visibility for visitors and clients.",
      "Professional reception sign solutions from A2Z Signs use high-quality materials, precision fabrication, and modern design techniques to deliver durable, visually appealing signage that reflects a strong corporate image and elevates the overall reception area experience."
    ],
    image: "/images/reception-signs.png"
  },
  {
    id: 26,
    title: "Illuminated Signs",
    meta_title: "Illuminated Signs for Business | A2Z Signs USA",
    meta_description: "A2Z Signs provides illuminated signs for businesses across the USA. Keep your brand visible 24 hours a day with premium LED lighting. Based in Upland, CA. Free quote available!",
    keywords: "illuminated signs for business USA",
    paragraphs: [
      "Illuminated Signs are custom lighting-based signage solutions designed to enhance brand visibility both day and night.",
      "They use integrated LED or backlit systems to create a bright, eye-catching display that helps businesses attract attention, improve recognition, and strengthen their overall brand presence.",
      "Professional illuminated signage solutions from A2Z Signs are crafted using high-quality materials, energy-efficient lighting technology, and precision fabrication to deliver durable, modern, and visually impactful signs suitable for indoor and outdoor business environments."
    ],
    image: "/images/illuminated-signs.png"
  },
  {
    id: 27,
    title: "Monument Signs",
    meta_title: "Custom Monument Signs for Business | A2Z Signs USA",
    meta_description: "A2Z Signs manufactures custom monument signs for businesses across the USA. Durable, impressive, and built to make a lasting impression. Based in Upland, CA. Free quote today!",
    keywords: "Custom Monument Signs for Business USA",
    paragraphs: [
      "Monument Signs are durable, ground-level signage structures designed to showcase business names, locations, and branding in a strong and highly visible format.",
      "Commonly installed at building entrances, roadways, commercial complexes, and institutional properties, they help improve wayfinding while creating a powerful first impression.",
      "Professional monument sign solutions from A2Z Signs are built using high-quality materials such as stone, metal, acrylic, and composite panels, ensuring long-lasting durability, weather resistance, and a bold architectural appearance that enhances overall brand identity."
    ],
    image: "/images/monument-signs.png"
  },
  {
    id: 28,
    title: "Pylon Signs",
    meta_title: "Custom Pylon Signs for Business | A2Z Signs USA",
    meta_description: "A2Z Signs creates custom pylon signs for businesses and shopping centers across the USA. High-visibility signage built to last. Based in Upland, CA. Get your free quote today!",
    keywords: "Custom Pylon Signs for Business USA",
    paragraphs: [
      "Pylon Signs are tall, freestanding signage structures designed to provide maximum visibility for businesses along highways, roads, shopping centers, and commercial properties.",
      "They are ideal for attracting attention from a distance and helping customers easily locate business locations.",
      "Professional pylon sign solutions from A2Z Signs are manufactured using strong steel frameworks, durable panels, and optional illuminated features to ensure long-lasting performance, high visibility, and a bold branding presence in both day and night environments."
    ],
    image: "/images/pylon-signs.png"
  },
  {
    id: 29,
    title: "Channel Letters",
    meta_title: "Channel Letter Signs for Business | A2Z Signs USA",
    meta_description: "A2Z Signs manufactures custom channel letter signs for businesses across the USA. Bold, 3D illuminated lettering built to last. Based in Upland, CA. Request your free quote today!",
    keywords: "Channel Letter Signs for Business USA",
    paragraphs: [
      "Channel Letters are 3D signage letters used on storefronts and commercial buildings to display business names in a clear and visible way.",
      "They can be made with or without lighting and help improve brand visibility for customers from a distance.",
      "Channel letter solutions from A2Z Signs are made using acrylic, aluminum, and LED lighting to provide strong, long-lasting, and eye-catching signage suitable for both indoor and outdoor use."
    ],
    image: "/images/channel-letters.png"
  },
  {
    id: 30,
    title: "Post & Panel Signs",
    meta_title: "Post & Panel Signs for Business | A2Z Signs USA",
    meta_description: "A2Z Signs offers custom post and panel signs for businesses across the USA. Versatile, durable, and professionally installed. Based in Upland, CA. Request your free quote today!",
    keywords: "Post and Panel Signs for Business USA",
    paragraphs: [
      "Post & Panel Signs are simple and effective outdoor signage systems used to display business names, directions, and property information.",
      "They are commonly installed for commercial spaces, real estate sites, institutions, and roadside locations to improve visibility and wayfinding.",
      "Post & panel sign solutions from A2Z Signs are made using durable posts and high-quality panels that ensure long-lasting performance, weather resistance, and clear visibility for both branding and directional purposes."
    ],
    image: "/images/post-and-panel-signs.png"
  },
  {
    id: 31,
    title: "Hanging Signs",
    meta_title: "Custom Hanging Signs for Business | A2Z Signs USA",
    meta_description: "A2Z Signs provides custom hanging signs for retail stores and businesses across the USA. Bold, eye-catching, and fully customized. Based in Upland, CA. Get a free quote today!",
    keywords: "Custom Hanging Signs for Business USA",
    paragraphs: [
      "Hanging Signs are suspended signage displays used to attract attention and guide customers inside retail stores, malls, restaurants, and commercial spaces.",
      "They are typically mounted from ceilings or brackets and help improve visibility in busy indoor environments.",
      "Hanging sign solutions from A2Z Signs are made using durable materials and custom designs to ensure strong visibility, long-lasting performance, and effective brand communication in both modern and traditional business settings."
    ],
    image: "/images/hanging-signs.png"
  },
  {
    id: 32,
    title: "Directories",
    meta_title: "Office Directory Signs for Buildings | A2Z Signs USA",
    meta_description: "A2Z Signs offers custom office directory signs for buildings across the USA. Clear, professional, and easy to navigate. Based in Upland, CA. Request your free quote today!",
    keywords: "Office Directory Signs for Buildings USA",
    paragraphs: [
      "Directories are signage systems used to guide visitors by displaying lists of rooms, offices, tenants, or departments inside buildings and commercial spaces[cite: 2].",
      "They help improve navigation, reduce confusion, and create an organized environment for customers and visitors.",
      "Directory sign solutions from A2Z Signs are designed using durable materials and clear layouts to ensure easy readability, long-lasting use, and effective wayfinding in offices, malls, hospitals, and corporate buildings."
    ],
    image: "/images/directory-boards.png"
  },
  {
    id: 33,
    title: "Directional Signs",
    meta_title: "Custom Directional Signs for Business | A2Z Signs USA",
    meta_description: "A2Z Signs provides custom directional signs for businesses and properties across the USA. Guide your customers with clear, professional signage. Based in Upland, CA. Free quote!",
    keywords: "Custom Directional Signs for Business USA",
    paragraphs: [
      "Directional Signs are wayfinding signs used to guide people to specific locations such as entrances, exits, parking areas, rooms, or departments.",
      "They help improve navigation, reduce confusion, and make movement easier in commercial, public, and industrial spaces.",
      "Directional sign solutions from A2Z Signs are made using durable materials and clear, easy-to-read designs to ensure strong visibility, long-lasting performance, and effective guidance in both indoor and outdoor environments."
    ],
    image: "/images/directional-wayfinding.png"
  },
  {
    id: 34,
    title: "Site Signs",
    meta_title: "Custom Construction Site Signs | A2Z Signs USA",
    meta_description: "A2Z Signs offers custom construction site signs for contractors and developers across the USA. Durable, visible, and fully compliant. Based in Upland, CA. Free quote available today!",
    keywords: "Construction Site Signs USA",
    paragraphs: [
      "Site Signs are informational and branding signs used at construction sites, commercial properties, and development areas to display project details, safety information, and company branding.",
      "They help improve visibility, communication, and site identification[cite: 2].",
      "Site sign solutions from A2Z Signs are made using durable materials and weather-resistant printing to ensure long-lasting performance, clear messaging, and strong visibility in outdoor environments."
    ],
    image: "/images/site-signs-construction.png"
  },
  {
    id: 35,
    title: "Yard Sign Riders",
    meta_title: "Custom Yard Sign Riders for Realtors | A2Z Signs USA",
    meta_description: "A2Z Signs provides custom yard sign riders for real estate agents across the USA. Boost your listings with bold, professional signage. Based in Upland, CA. Free quote available!",
    keywords: "Custom Yard Sign Riders for Realtors USA",
    paragraphs: [
      "Yard Sign Riders are small add-on signs placed above or below main yard signs to display extra information such as contact details, pricing, directions, or short messages.",
      "They help increase visibility and provide additional marketing space without changing the main sign.",
      "Yard sign rider solutions from A2Z Signs are made using durable materials and high-quality printing to ensure clear messaging, strong outdoor performance, and easy installation on standard yard sign frames."
    ],
    image: "/images/yard-sign-riders.png"
  },
  {
    id: 36,
    title: "Yard Signs",
    meta_title: "Custom Yard Sign Riders for Realtors | A2Z Signs USA",
    meta_description: "A2Z Signs provides custom yard sign riders for real estate agents across the USA. Boost your listings with bold, professional signage. Based in Upland, CA. Free quote available!",
    keywords: "Custom Yard Sign Riders for Realtors USA",
    paragraphs: [
      "Yard Signs are lightweight outdoor signs used for advertising, promotions, real estate listings, events, and directional messaging.",
      "They are commonly placed in open areas such as lawns, roadside spaces, and construction sites to attract attention and deliver quick information.",
      "Yard sign solutions from A2Z Signs are made using durable materials and high-quality printing to ensure strong visibility, weather resistance, and effective short-term or long-term outdoor use."
    ],
    image: "/images/yard-signs.png"
  },
  {
    id: 37,
    title: "Real Estate Signs",
    meta_title: "Custom Real Estate Signs | A2Z Signs USA",
    meta_description: "A2Z Signs offers custom real estate signs for agents and developers across the USA. Professional, durable, and designed to sell. Based in Upland, CA. Request a free quote today!",
    keywords: "Custom Real Estate Signs USA",
    paragraphs: [
      "Real Estate Signs are outdoor signage solutions used to promote property listings, rentals, sales, and open house events.",
      "They help real estate agents and property owners attract potential buyers and provide clear contact and property information",
      "Real estate sign solutions from A2Z Signs are made using durable materials and high-quality printing to ensure strong outdoor visibility, weather resistance, and effective marketing performance for residential and commercial properties."
    ],
    image: "/images/real-estate-signs.png"
  },
  {
    id: 38,
    title: "Registration Lettering",
    meta_title: "Custom Registration Lettering | A2Z Signs USA",
    meta_description: "A2Z Signs provides custom registration lettering for boats and vehicles across the USA. Precise, compliant, and professionally applied. Based in Upland, CA. Free quote available!",
    keywords: "Custom Registration Lettering USA",
    paragraphs: [
      "Registration Lettering is custom-cut lettering used for vehicle, storefront, or business identification, where letters and graphics are precisely designed to display names, logos, or registration details in a clean and visible format.",
      "It helps improve brand recognition and provides a professional look for vehicles, windows, and signage surfaces.",
      "Registration lettering solutions from A2Z Signs are made using high-quality vinyl and precision cutting technology to ensure accurate detailing, strong adhesion, and long-lasting performance for indoor and outdoor applications."
    ],
    image: "/images/registration-lettering.png"
  },
  {
    id: 39,
    title: "Boat Registration",
    meta_title: "Boat Registration Numbers and Lettering | A2Z Signs USA",
    meta_description: "A2Z Signs offers boat registration numbers and lettering across the USA. Marine-grade materials built to withstand water and UV exposure. Based in Upland, CA. Free quote today!",
    keywords: "Boat Registration Numbers and Lettering USA",
    paragraphs: [
      "Boat Registration is identification lettering applied to boats to display registration numbers, vessel names, or ownership details as required for compliance and easy recognition.",
      "It helps ensure legal identification while also adding a clean and customized appearance to the boat.",
      "Boat registration lettering solutions from A2Z Signs are made using high-quality marine-grade vinyl and precision cutting to ensure strong adhesion, weather resistance, and long-lasting durability in water and outdoor environments."
    ],
    image: "/images/registration-lettering.png"
  },
  {
    id: 40,
    title: "DOT Registration",
    meta_title: "DOT Registration Numbers for Trucks | A2Z Signs USA",
    meta_description: "A2Z Signs provides DOT registration numbers for commercial trucks across the USA. Stay compliant with bold, durable lettering. Based in Upland, CA. Request your free quote today!",
    keywords: "DOT Registration Numbers for Trucks USA",
    paragraphs: [
      "DOT Registration is required identification lettering used on commercial vehicles to display Department of Transportation numbers and compliance details",
      "It helps ensure vehicles meet legal requirements while making them easily identifiable for inspections and transport regulations[cite: 2].",
      "DOT registration lettering solutions from A2Z Signs are made using high-quality vinyl and precision cutting technology to ensure clear visibility, strong adhesion, and long-lasting durability for trucks, trailers, and commercial fleet vehicles."
    ],
    image: "/images/fleet-wraps.png"
  }
];